import styled, { keyframes } from 'styled-components';

const scaleIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.85);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;

export const Container = styled.div`
  position: relative;
  animation: ${scaleIn} 0.35s ease;
  border-radius: 8px;
  overflow: hidden;
  max-width: 860px;
  width: 100%;

  @media (max-width: 600px) {
    max-width: 380px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.55);
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  z-index: 1;
  transition: background 0.2s;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
  }
`;

export const BannerDesktop = styled.img`
  display: block;
  width: 100%;
  height: auto;

  @media (max-width: 600px) {
    display: none;
  }
`;

export const BannerMobile = styled.img`
  display: none;
  width: 100%;
  height: auto;

  @media (max-width: 600px) {
    display: block;
  }
`;
